import React from 'react';
import Modal from '../../components/Modal';
import ModalHeading from '../../components/Modal/ModalHeading';
import ModalForm from '../../components/Modal/ModalForm';
import InputsSection from '../../components/Modal/InputsSection';
import TextInput from '../../components/TextInput';
import ModalButtons from '../../components/Modal/ModalButtons';

const AddDeniedModal = ({ data }) => {
	const {
		addDeniedListModalStatus,
		newDeniedText,
		setNewDeniedText,
		newDeniedFile,
		setNewDeniedFile,
		closeModal,
		handleAddDenied
	} = data;
	return (
		<Modal show={addDeniedListModalStatus.status}>
			<ModalHeading heading={`Add ${addDeniedListModalStatus.type} Input`} subHeading='(Choose any one)' />
			<ModalForm>
				<InputsSection style={{ alignItems: 'flex-start' }}>
					<TextInput
						icon='lock'
						label={`Single ${addDeniedListModalStatus.type} Input`}
						placeholder={`Single ${addDeniedListModalStatus.type} Input`}
						value={newDeniedText.value}
						onChange={(e) => setNewDeniedText({ value: e.target.value, error: '' })}
						errorMessage={newDeniedText.error}
					/>
					<div
						style={{
							height: '10rem',
							width: '.5px',
							backgroundColor: 'var(--grey)'
						}}
					/>
					<TextInput
						icon='lock'
						type='file'
						label={`Multiple ${addDeniedListModalStatus.type} Input`}
						placeholder={`Multiple ${addDeniedListModalStatus.type} Input`}
						disabled={newDeniedText.value !== ''}
						// value={newIOCFile.value}
						onChange={(e) => {
							setNewDeniedFile({ value: e.target.files[0], error: '' });
							setNewDeniedText({ value: '', error: '' });
						}}
						errorMessage={newDeniedFile.error}
					/>
				</InputsSection>
				<ModalButtons
					submitButtonLabel={`Add ${addDeniedListModalStatus.type}`}
					onSubmit={handleAddDenied}
					cancelButtonLabel='Cancel'
					onCancel={closeModal}
				/>
			</ModalForm>
		</Modal>
	);
};

export default AddDeniedModal;
